import React, { Component } from 'react';
import {injectStripe,CardElement} from 'react-stripe-elements';
import './Input.css';
import './Input-CreditCard-StripeElements.css';

class InputCreditCard extends Component {
  

  constructor(props) {
    super(props);
    
    this._handleBlur = this._handleBlur.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleFocus = this._handleFocus.bind(this);
    this._reset = this._reset.bind(this);

    this.state = {
      card_lastfour:this.props.card_lastfour,
      card_token:this.props.card_token
    };

  }

  componentWillReceiveProps(newProps) {
      
      this.setState({
        card_lastfour:newProps.card_lastfour,
        card_token:newProps.card_token
      });
    
  }
  
  render() {

      return (

        <div>

          {this.state.card_token ?

            <div className="fieldSet">
              <div className="clearflex justify-flex-start">
                <label>Card Numbers</label>
              </div>
              <p>• •• ••• •••• {this.state.card_lastfour} <a onClick={this._reset}>&times;</a></p>
            </div>

          :
          
            <div className="fieldSet">
              <div className="clearflex justify-flex-start">
                <label>Card Numbers</label>
              </div>
                <CardElement
                  classes={{
                    base:"StripeContainer",
                    focus:"StripeContainer-Focus"
                  }}
                  onBlur={this._handleBlur}
                  onFocus={this._handleFocus}
                  style={{
                    base: {
                      color:'rgba(0,0,0,.75)',
                      fontSize: '20px',
                      '::placeholder':{
                        color:'rgba(0,0,0,.75)'
                      }
                    }
                  }}
                  value={{
                    postalCode:this.state.card_zip
                  }}
                />
            </div>

          }
        
        </div>
      );
    
  }





  _reset() {
    this.setState({
      card_token:"",
      card_lastfour:""
    },function() {
      if (this.props.onBlur) {
        this.props.onBlur("","");
      }
    });
  }



  _handleBlur(event) {

    var _this = this;

    // get stripe token
    this.props.stripe.createToken().then(({token,error}) => {
      //console.log('Received Stripe token:', token, error);
      //console.log(token.card.last4,token.id);

      if (token) {
        _this.setState({
          card_token:token.id,
          card_lastfour:token.card.last4
        });

        if (this.props.onBlur) {
          this.props.onBlur(token.id,token.card.last4);
        }
      }

      if (error) {

      }

    });


  }

  _handleChange(event) {
    
    var name = event.target.name;
    var value = event.target.value;

    this.setState({
      
      [name]:value,

    },function() {
      if (this.props.onChange) {
       
      }
    });
  }

  _handleFocus(event) {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }


}

export default injectStripe(InputCreditCard);



// WEBPACK FOOTER //
// ./src/components/Input-CreditCard-StripeElements.js